import { render, staticRenderFns } from "./FrameItem.vue?vue&type=template&id=52f04932&scoped=true&"
import script from "./FrameItem.vue?vue&type=script&lang=js&"
export * from "./FrameItem.vue?vue&type=script&lang=js&"
import style0 from "./FrameItem.vue?vue&type=style&index=0&id=52f04932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f04932",
  null
  
)

export default component.exports